import { httpBatchLink, loggerLink } from '@trpc/client';
import type { TRPCClient } from '@trpc/client';
import type { GraphRouter } from '@org/graph-server';
import type { QueryClient } from '@tanstack/react-query';
import { createTRPCReact } from '@trpc/react-query';
import superjson from 'superjson';
import { createContext } from 'react';
import { sentryLink } from '../lib/sentry-link';

export const GraphTrpcContext = createContext(null);
export const graphTrpc = createTRPCReact<GraphRouter>({ context: GraphTrpcContext });

export interface CreateGraphClientOptions {
  queryClient: QueryClient;
  getAccessToken: () => Promise<string>;
  /** Extra headers attached to every request (e.g. admin impersonation). */
  getExtraHeaders?: () => Record<string, string>;
  apiUrl?: string;
  transformer?: typeof superjson;
}

export const createGraphTrpcClient = ({
  queryClient,
  getAccessToken,
  getExtraHeaders,
  apiUrl = 'http://localhost:3334/graph',
  transformer = superjson,
}: CreateGraphClientOptions): TRPCClient<GraphRouter> => {
  return graphTrpc.createClient({
    // @ts-ignore
    transformer,
    links: [
      loggerLink({
        enabled: (opts) =>
          process.env.NODE_ENV === 'development' &&
          // @ts-ignore
          (typeof window !== 'undefined' ? true : opts.direction === 'down'),
      }),
      sentryLink<GraphRouter>({ source: 'graph' }),
      httpBatchLink({
        url: apiUrl,
        // @ts-ignore
        transformer,
        async headers() {
          const extra = getExtraHeaders?.() ?? {};
          try {
            const token = await getAccessToken();
            return {
              ...extra,
              Authorization: `Bearer ${token}`,
            };
          } catch (error) {
            console.error('Failed to get access token for graph tRPC request', error);
            return extra;
          }
        },
      }),
    ],
  });
};
